import React, {createContext, useContext, useState} from "react";

const MessageContext = createContext();

export const useMessage = () => {
  const context = useContext(MessageContext);
  if (context === undefined) {
    throw new Error("useMessage debe estar dentro del proveedor MessageProvider");
  }
  return context;
};

export function Message({ messages, type, source }) {
  if (source) {
    const filteredMessages = messages.filter(
      (message) => message.source === source || message.source === null || message.source === undefined
    );

    return (
      <React.Fragment>
        {filteredMessages?.length > 0 && (
          <div className={`message animated fadeIn ${type}`} style={{ marginBotton: "10px" }}>
            <ul>
              {messages.map((m, i) => {
                return <li key={`m-${i}`}>{m.message}</li>;
              })}
            </ul>
          </div>
        )}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {messages?.length > 0 && (
        <div className={`message animated fadeIn ${type}`} style={{ marginBotton: "10px" }}>
          <ul>
            {messages.map((m, i) => {
              return <li key={`m-${i}`}>{m.message}</li>;
            })}
          </ul>
        </div>
      )}
    </React.Fragment>
  );

  return null;
}

export function MessageProvider({ children }) {
  
  const [messages, setMessages] = useState([]);
  const [typeMessages, setTypeMessages] = useState("warning");

  const handleMessage = (message, type) => {
    setMessages((prevState) => {
      if (!prevState.some((msg) => msg.message === message)) {
        return [...prevState, { message }];
      } else {
        return prevState;
      }
    });
    setTypeMessages(type);
  };

  const handleMessageWithSource = (message, type, source) => {
    setMessages((prevState) => {
      if (!prevState.some((msg) => msg.message === message)) {
        return [...prevState, { message, source }];
      } else {
        return prevState;
      }
    });
    setTypeMessages(type);
  };

  const handleException = (error, source) => {
    if (source) {
      if (error?.Interno) {
        handleMessageWithSource(error?.Mensaje, "error", source);
      } else if (error?.Mensaje === "Error en la aplicación favor comunicarse con el administrador") {
        handleMessageWithSource(error?.Mensaje, "error", source);
      } else if (error?.Mensaje) {
        handleMessageWithSource(error?.Mensaje, "warning", source);
      }
    } else {
      if (error?.Interno) {
        handleMessage(error?.Mensaje, "error");
      } else if (error?.Mensaje === "Error en la aplicación favor comunicarse con el administrador") {
        handleMessage(error?.Mensaje, "error");
      } else if (error?.Mensaje) {
        handleMessage(error?.Mensaje, "warning");
      }
    }
  };

  const handleOk = (message, timer) => {
    handleMessage(message, "ok");
    if (timer) {
      setTimeout(() => {
        clearMessages();
      }, timer * 1000);
    }
  };

  const clearMessages = () => {
    setMessages([]);
  };

  return (
    <MessageContext.Provider value={{ messages, typeMessages, handleException, handleOk, clearMessages }}>
      {children}
    </MessageContext.Provider>
  );
}
